module.exports = __webpack_public_path__ + "static/media/profilePhoto.8f981008.png";